import { StringHelper } from "./StringHelper";
import { NAMESPACE } from "./_Namespace";

export class NumberHelper
{
    public static classNamespace = NAMESPACE + "NumberHelper";
    public static className = "NumberHelper";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Public Methods

    public static isNumeric(n: any)
    {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    public static range(start: number, count: number): number[]
    {
        const
            returnValue: number[] = [];

        if (count > 0)
        {
            for (let i = 0; i < count; i++)
                returnValue.push(start + i);
        }

        return returnValue;
    }
    public static toStringAbbreviated(number: number, dp: number)
    {
        const
            decimalPlaces = Math.pow(10, dp ?? 2),
            suffixes = [StringHelper.empty, "K", "M", "B", "T"];

        let
            suffix: string = StringHelper.empty;

        for (let i = suffixes.length - 1; i >= 0; i--)
        {
            const
                size = Math.pow(10, i * 3);

            if (size <= Math.abs(Math.round(number)))
            {
                number = Math.round(number * decimalPlaces / size) / decimalPlaces;

                if (number === 1000 && i < suffixes.length - 1)
                {
                    number = 1;
                    i++;
                }

                suffix = suffixes[i];
                break;
            }
        }

        return number.toString() + suffix;
    }
    public static toStringFormat(n: number, format?: string)
    {
        if (format)
        {
            return (
                format.replace(/{([^:]+)(?::([0-9]*))?}/gi, (_, p1, p2) =>
                {
                    switch (p1.toLowerCase())
                    {
                        case "n":
                            return n.toLocaleString(undefined, { minimumFractionDigits: p2, maximumFractionDigits: p2 });
                        default:
                            return n.toString();
                    }
                })
            );
        }

        return n.toString();
    }

    // #endregion
}